import Vue from "vue";
import axios from "axios";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router.js";
import store from "./store";

// Amlify関連ライブラリのインポート
import VueRouter from "vue-router";
// import Amplify, * as AmplifyModules from "aws-amplify";
// import { AmplifyPlugin } from "aws-amplify-vue";
// import config from "./aws-exports.js";

// プラグインのアクティベートdayo
// Amplify.configure(config);
// Vue.use(AmplifyPlugin, AmplifyModules);
Vue.use(VueRouter);

Vue.config.productionTip = false;
axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT;

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount("#app");